import _extends from "@babel/runtime/helpers/extends";
import { useOption } from "@react-aria/listbox";
import React, { useRef } from "react";
import { extractStylingProps } from "../../shared";
import { StyledListBox } from "../internal/StyledListBox";
export function ComboBoxOption(_ref) {
  let {
    item,
    state,
    ...ariaOptionProps
  } = _ref;
  const ref = useRef(null);
  const {
    isDisabled,
    isFocused,
    isPressed,
    isSelected,
    optionProps
  } = useOption({
    key: item.key,
    ...ariaOptionProps
  }, state, ref);
  const stateProps = {
    isDisabled,
    isFocused,
    isPressed,
    isSelected
  };
  const [stylingProps] = extractStylingProps(item.props);
  return /*#__PURE__*/React.createElement(StyledListBox.Item, _extends({}, optionProps, stateProps, stylingProps, {
    ref: ref
  }), item.rendered);
}
//# sourceMappingURL=ComboBoxOption.js.map